import { HOSTED_PAGE_TYPES_TOKENS } from 'consts';
import localStorageService from 'services/localStorage';
import { getHostedPageType } from 'utilities/global';
import { HOSTED_CARD_TOKENIZATION } from 'routes/paths';

export const usePageToken = () => {
  const { searchParams, pathname } = new URL(window.location.href);
  const { token: urlToken } = Object.fromEntries(searchParams);

  const hostedPageType = getHostedPageType();
  let pageToken;
  const routesWithNoToken = [HOSTED_CARD_TOKENIZATION];
  if (routesWithNoToken.includes(window?.location?.pathname)) {
    pageToken = `random_opaque_token_${Date.now()}`;
  }
  if (!pageToken) {
    pageToken = urlToken;
  }
  if (!pageToken) {
    pageToken = extractTokenFromPathname(pathname);
  }
  if (!pageToken) {
    pageToken = localStorageService.getItem(HOSTED_PAGE_TYPES_TOKENS[hostedPageType]);
  }

  return pageToken;
};

function extractTokenFromPathname(pathname) {
  const hostedPageType = getHostedPageType();
  const hostedPageTokenPrefix = HOSTED_PAGE_TYPES_TOKENS[hostedPageType];
  if (!hostedPageTokenPrefix) {
    return;
  }
  if (!pathname || pathname === '') {
    return;
  }
  const indexOfTokenPrefix = pathname.indexOf(hostedPageTokenPrefix);
  if (indexOfTokenPrefix === -1) {
    return;
  }
  const indexOfEndOfTokenPrefix = indexOfTokenPrefix + hostedPageTokenPrefix.length;
  const afterPrefix = pathname[indexOfEndOfTokenPrefix];
  if (afterPrefix !== '_') {
    return;
  }
  const endOfTokenIndex = pathname.indexOf('/', afterPrefix);
  const indexOfTokenPrefixEnd =
    endOfTokenIndex > indexOfTokenPrefix ? endOfTokenIndex : undefined;
  return pathname.substring(indexOfTokenPrefix, indexOfTokenPrefixEnd);
}
